<script>
  import { createEventDispatcher } from 'svelte';
  import { Modal, ModalBody, ModalFooter, ModalHeader, CustomInput } from 'sveltestrap';
  import http from '../api/http.js';
  import Tooltip from '../reusable components/Tooltip.svelte'
  import { selectedGroup } from '../store';

  const toggleForceRestart = () => forceRestart = !forceRestart;
  const dispatch = createEventDispatcher();

  let installerTooltip = [
    {
      "name": "Example 1",
      "value": "/quiet",
      "color": "info"
    },
    {
      "name": "Example 2",
      "value": "/S",
      "color": "info"
    },
    {
      "name": "More Information",
      "value": "For more information about installer arguments, please refer to your install documentation",
      "color": "primary"
    },
  ];

  let shown = false;
  let version;
  let errorMessage = "";
  let description = "";
  let installerArguments = "";
  let forceRestart = 0;
  let restartTimer = 0;
  let restartMessage = "";
  let preInstall = "";
  let postInstall = "";
  let destination = "";
  let isValid = true;

  let errors = {
    description: '',
    installerArguments: '',
    restartTimer: '',
    restartMessage: '',
    preInstall: '',
    postInstall: '',
    destination: '',
  };

  export async function show(versionArg) {
    version = versionArg;
    description = version.description;
    installerArguments = version.installerArgs;
    forceRestart = version.forceRestart;
    restartTimer = version.restartCountTime;
    restartMessage = version.restartMessage;
    preInstall = version.preInstall;
    postInstall = version.postInstall;
    destination = version.destination;
    
    errors = {
      description: '',
      installerArguments: '',
      restartTimer: '',
      restartMessage: '',
      preInstall: '',
      postInstall: '',
      destination: '',
    };

    shown = true;
  }

  function toggle() {
    if(shown){
      shown = false;
      resetModal();
    }else{
      shown = true;
    }
  }

  function resetModal(){
    errorMessage = "";
  }

  function validate() {
    isValid = true;

    if(version.installer){
      if(description.length > 100){
        errors.description = 'Description must be 100 characters or less';
        isValid = false;
      }else{
        errors.description = '';
      }

      if(installerArguments.length > 512){
        errors.installerArguments = 'Installer Arguments must be 512 characters or less';
        isValid = false;
      }else{
        errors.installerArguments = '';
      }

      let regex = /^[0-9]+$/;

      if(!regex.test(restartTimer)){
        errors.restartTimer = 'Restart Timer must be numerical';
        isValid = false;
      }else{
        errors.restartTimer = '';
      }

      if(restartMessage.length > 100){
        errors.restartMessage = 'Restart Message must be 100 characters or less';
        isValid = false;
      }else{
        errors.restartMessage = '';
      }

      if(preInstall.length > 1024){
        errors.preInstall = 'Pre-Install Commands must be 1024 characters or less';
        isValid = false;
      }else{
        errors.preInstall = '';
      }

      if(postInstall.length > 1024){
        errors.postInstall = 'Post-Install Commands must be 1024 characters or less';
        isValid = false;
      }else{
        errors.postInstall = '';
      }
    }else{
      if(!destination){
        errors.destination = 'Destination cannot be blank';
        isValid = false;
      }else if(destination.length > 1024){
        errors.destination = 'Destination must be 1024 characters or less';
        isValid = false;
      }else{
        errors.destination = '';
      }
    }

    return isValid;
  }

  async function editVersion() {
    if(validate()){
      version.description = description;
      version.installerArgs = installerArguments;
      version.forceRestart = forceRestart;
      version.restartCountTime = restartTimer;
      version.restartMessage = restartMessage;
      version.preInstall = preInstall;
      version.postInstall = postInstall;
      version.destination = destination;

      const res = await http.put(window.apiBaseUrl + `/deploy/dashboard/software/version/${$selectedGroup}`,	version);

      if (res.ok) {
        dispatch('versionEdited');
        shown = false;
      }
    }
  }

  function _onYes() {
    editVersion();
    shown = false;
  }

  function _onNo() {
    shown = false;
  }

</script>

<Modal size="lg" isOpen={shown} {toggle}>
  <ModalHeader {toggle}>Edit Package Version</ModalHeader>
  <ModalBody>
    <div class="row">
      <div class="col">
        <h4 class="input-header mt-2 m-2 mb-2">Name</h4>
        <input id="software-name-input" type="text" class="form-control" placeholder={version.name} disabled/>
      </div>
      <div class="col">
        <h4 class="input-header mt-2 mb-2 m-2">Description</h4>
        <input id="version-description-input" type="text" class="form-control" bind:value={description} on:input={() => validate()}/>
        <p class="text-danger">{errors.description}</p>
      </div>
    </div>
    {#if version.installer}
      <div class="d-flex mt-2 mb-2">
        <h4 class="input-header mb-3 m-2">
          Installer Arguments
          <Tooltip content={installerTooltip} legend={true} title={'Installer Arguments'}>
            <i class="fad fa-question-circle fa-sm font-weight-normal"></i>
          </Tooltip>
        </h4>
      </div>
      {#if version.installerArgs != null}
        <input id="installer-arguments-input" type="text" class="form-control" bind:value={installerArguments} on:input={() => validate()}/>
      {:else}
        <input id="installer-arguments-input" type="text" class="form-control" placeholder="Installer Arguments" bind:value={installerArguments} on:input={() => validate()}/>
      {/if}
      <p class="text-danger">{errors.installerArguments}</p>
      <div class="d-flex mt-2 mb-2">
        <h4 class="modalHeading m-2">Restart Settings</h4>
        <CustomInput type="switch" checked={forceRestart == true} id="setforceRestart" label="Enable Force Restart" class="ml-auto" on:change={() => toggleForceRestart()}></CustomInput>
      </div>
      <div>
        <h4 class="input-header mb-3 m-2">Restart Timer (Seconds)</h4>
        <input type="number" class="form-control" id="restart-countdown-time" min="0" bind:value={restartTimer} disabled={!forceRestart} on:input={() => validate()}/>
        <p class="text-danger">{errors.restartTimer}</p>
        <h4 class="input-header mb-3 m-2">Custom Restart Message</h4>
        {#if version.restartMessage != ""}
          <input id="restart-message-input" type="text" class="form-control" bind:value={restartMessage} disabled={!forceRestart} on:input={() => validate()}/>
        {:else}
          <input id="restart-message-input" type="text" class="form-control" bind:value={restartMessage} disabled={!forceRestart} on:input={() => validate()}/>
        {/if}
        <p class="text-danger">{errors.restartMessage}</p>
      </div>
      <div class="mt-2 mb-2">
        <div class="d-flex">
          <h4 class="input-header mb-3 m-2">Pre-Install Commands</h4>
        </div>
        {#if version.preInstall != null}
          <textarea id="pre-install-input" class="form-control" bind:value={preInstall} disabled={version.usePreExistingPreInstallCommands == true} on:input={() => validate()}/>
        {:else}
          <textarea id="pre-install-input" class="form-control" bind:value={preInstall} placeholder="Pre-Install (.bat commands)" disabled={version.usePreExistingPreInstallCommands == true} on:input={() => validate()}/>
        {/if}
        <p class="text-danger">{errors.preInstall}</p>
        <div class="mt-2 mb-2">
          <div class="d-flex">
            <h4 class="input-header mt-2 mb-3 m-2">Post Install Commands</h4>
          </div>
          {#if version.postInstall != null}
            <textarea id="post-install-input" class="form-control" bind:value={postInstall} disabled={version.usePreExistingPostInstallCommands == true} on:input={() => validate()}/>
          {:else}
            <textarea id="post-install-input" class="form-control" bind:value={postInstall} placeholder="Post-Install (.bat commands)" disabled={version.usePreExistingPostInstallCommands == true} on:input={() => validate()}/>
          {/if}
          <p class="text-danger">{errors.postInstall}</p>
        </div>
      </div>
    {:else}
      <div class="mt-2 mb-2">
        <div class="d-flex">
          <h4 class="input-header mt-2 m-2">Destination Path</h4>
        </div>
        {#if version.destination != null}
          <input id="destination-input" type="text" class="form-control use-existing"bind:value={destination} on:input={() => validate()}/>
        {:else}
          <input id="destination-input" type="text" class="form-control use-existing" placeholder="Destination Path" bind:value={destination} on:input={() => validate()}/>
        {/if}
        <small>Must be a system file path eg: C:\Transfers</small>
        <p class="text-danger">{errors.destination}</p>
      </div>
    {/if}
  </ModalBody>
  <ModalFooter>
    <button id="edit-version-cancel-button" class="btn btn-outline-primary" on:click={() => _onNo()}>Cancel</button>
    <button id="edit-version-confirm-button" on:click={() => _onYes()} class="btn btn-primary" disabled={!isValid}>Confirm</button>
  </ModalFooter>
</Modal>

<style>
  @import "@uppy/core/dist/style.css";
  @import "@uppy/dashboard/dist/style.css";

  .modalHeading{
    font-weight: 500;
  }

  textarea {
    white-space: nowrap;
    max-height: 150px;
  }

  input[type="text"]:disabled{
    background-color: #e9ecef;
  }
</style>